import SelectBox from "components/Common/SelectBox"
import React from "react"
import { Card, CardBody, Col, Input, Label, Row, Table } from "reactstrap"
import { Checkbox, DropdownSelect, RadioInput, TextInput } from "../Inputs"
import PaymentForm from "../PaymentForm"
import DateInput from "components/Common/DateInput"
import { BranchOptions, FabricOptions } from "components/CustomSelect"
import DimensionInput from "components/Common/DimensionInput"

export default function JacketTab(props) {
  const { data, payload, config } = props
  const { handleInput } = config

  const handleOtherDimension = (e, obj, i) => {
    const data = {
      formId: obj.formId,
      sequence: obj.sequence,
      answer: e.target.value,
    }

    handleInput({ data, type: "otherDimensions", index: i, itemName: "jacket" })
  }

  return (
    <Row>
      <Col sm={12}>
        <Card>
          <CardBody>
            <Row>
              <Col sm={6}>
                <Table bordered>
                  <tbody>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>店舗</td>
                      <td style={{ padding: 5 }}>
                        <SelectBox
                          // options={config.branches}
                          isAsync
                          loadOptions={config.loadBranch}
                          value={config.branch}
                          onChange={e => handleInput({ e, type: "storeId" })}
                          formatOptionLabel={item => (
                            <BranchOptions item={item} />
                          )}
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>種別</td>
                      <td style={{ padding: 5 }}>
                        <Row>
                          <Col>
                            <Input
                              defaultChecked={payload.type === "Bespoke"}
                              onClick={e => handleInput({ e, type: "type" })}
                              className="me-2"
                              type="radio"
                              id="BeSpoke"
                              name="type"
                              value="Bespoke"
                            />
                            <Label htmlFor="BeSpoke" className="mb-0">
                              Bespoke
                            </Label>
                          </Col>
                          <Col>
                            <Input
                              defaultChecked={payload.type === "MTM"}
                              onClick={e => handleInput({ e, type: "type" })}
                              className="me-2"
                              type="radio"
                              id="MTM"
                              name="type"
                              value="MTM"
                            />
                            <Label htmlFor="MTM" className="mb-0">
                              MTM
                            </Label>
                          </Col>
                          <Col>
                            <Input
                              defaultChecked={payload.type === "RTW"}
                              onClick={e => handleInput({ e, type: "type" })}
                              className="me-2"
                              type="radio"
                              id="RTW"
                              name="type"
                              value="RTW"
                            />
                            <Label htmlFor="RTW" className="mb-0">
                              RTW
                            </Label>
                          </Col>
                        </Row>
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>仮縫い</td>
                      <td style={{ padding: 5 }}>
                        <Row>
                          <Col>
                            <Input
                              defaultChecked={payload.basting}
                              onChange={e =>
                                handleInput({ e, type: "basting", value: true })
                              }
                              className="me-2"
                              type="radio"
                              name="basting"
                              id="bastingOn"
                            />
                            <Label htmlFor="bastingOn" className="mb-0">
                              あり
                            </Label>
                          </Col>
                          <Col>
                            <Input
                              defaultChecked={!payload.basting}
                              onChange={e =>
                                handleInput({
                                  e,
                                  type: "basting",
                                  value: false,
                                })
                              }
                              className="me-2"
                              name="basting"
                              id="bastingOff"
                              type="radio"
                            />
                            <Label htmlFor="bastingOff" className="mb-0">
                              なし
                            </Label>
                          </Col>
                        </Row>
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>仮縫い日</td>
                      <td style={{ padding: 5 }}>
                        <DateInput
                          disabled={!payload.basting}
                          style={{ height: 33 }}
                          className="form-control"
                          name="fittingDate"
                          onChange={([e]) =>
                            handleInput({ e, type: "fittingDate" })
                          }
                          value={payload.fittingDate}
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}> 納期日 </td>
                      <td style={{ padding: 5 }}>
                        <DateInput className="form-control" disabled />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}> 出来上日 </td>
                      <td style={{ padding: 5 }}>
                        <DateInput
                          style={{ height: 33 }}
                          className="form-control"
                          onChange={() => null}
                          disabled={true}
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col sm={6}>
                <Table bordered>
                  <tbody>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>顧客名</td>
                      <td style={{ padding: 5 }}>
                        <SelectBox
                          isAsync
                          loadOptions={config.loadCustomer}
                          defaultOptions={config.customers}
                          value={config.customerId}
                          onChange={e => handleInput({ e, type: "customerId" })}
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54, opacity: config.guestHidden }}>
                      <td style={{ width: 105 }}>
                        <Input
                          className="me-2"
                          type="checkbox"
                          defaultChecked={!payload.guest || !config.guestHidden}
                          onChange={e => handleInput({ e, type: "guest" })}
                          name="guest"
                          id="guest"
                        />
                        <Label htmlFor="guest" className="mb-0">
                          新規お客様
                        </Label>
                      </td>
                      <td style={{ padding: 5 }}>
                        <Input
                          type="text"
                          style={{ height: 33 }}
                          placeholder="ゲスト名を入力"
                          name="guestName"
                          value={payload.guestName}
                          onChange={e => handleInput({ e, type: "guestName" })}
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>受注日</td>
                      <td style={{ padding: 5 }}>
                        <DateInput
                          style={{ height: 33 }}
                          className="form-control"
                          name="orderDate"
                          value={payload.orderDate}
                          onChange={([e]) =>
                            handleInput({ e, type: "orderDate" })
                          }
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>担当者</td>
                      <td style={{ padding: 5 }}>
                        <Input disabled type="text" style={{ height: 33 }} />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>プライス税抜</td>
                      <td style={{ padding: 5 }}>
                        {/* <Input
                          type="number"
                          style={{ height: 33 }}
                          className="form-control"
                          name="priceWithoutTax"
                          defaultValue={payload.jacket.priceWithoutTax || ""}
                          value={payload.jacket.priceWithoutTax || ""}
                          onChange={e =>
                            handleInput({
                              e,
                              type: "priceWithoutTax",
                              itemName: "jacket",
                            })
                          }
                        /> */}

                        <DimensionInput
                          name="priceWithoutTax"
                          defaultValue={payload.jacket.priceWithoutTax || ""}
                          value={payload.jacket.priceWithoutTax || ""}
                          onValueChange={(e, name) =>
                            handleInput({
                              e,
                              type: name,
                              itemName: "jacket",
                            })
                          }
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>プライス税込</td>
                      <td style={{ padding: 5 }}>
                        {/* <Input
                          type="text"
                          style={{ height: 33 }}
                          className="form-control"
                          disabled
                          readOnly
                          defaultValue={payload.jacket.priceTaxIncluded}
                          value={payload.jacket.priceTaxIncluded}
                        /> */}

                        <DimensionInput
                          defaultValue={payload.jacket.priceTaxIncluded}
                          value={payload.jacket.priceTaxIncluded}
                          disabled
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>

            <Row>
              <Col sm={6}>
                <Table bordered>
                  <tbody>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>⽣地商社</td>
                      <td style={{ padding: 5 }}>
                        <SelectBox
                          isAsync={true}
                          defaultOptions={config.fabricTradings}
                          loadOptions={config.loadFabricTrading}
                          options={config.fabricTradings}
                          value={config.fabricTrading}
                          onChange={e =>
                            config.handleInput({ e, type: "fabricCompanyId" })
                          }
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>⽣地年度</td>
                      <td style={{ padding: 5 }}>
                        <SelectBox
                          options={config.years}
                          value={config.year}
                          onChange={e => handleInput({ e, type: "year" })}
                          isDisabled={
                            !config.fabricTrading ||
                            config.fabricTrading?.value === ""
                          }
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>混率</td>
                      <td style={{ padding: 5 }}>
                        <Input
                          type="text"
                          value={config.rank?.mixedRatio}
                          disabled
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>⽣地⼱</td>
                      <td style={{ padding: 5 }}>
                        <Input
                          type="text"
                          // value={config.rank?.clothWidth}
                          value={data.clothWidth}
                          readOnly
                          disabled
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col sm={6}>
                <Table bordered>
                  <tbody>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>⽣地</td>
                      <td style={{ padding: 5 }}>
                        <SelectBox
                          isAsync
                          loadOptions={config.loadFabrics}
                          defaultOptions={config.fabrics}
                          defaultValue={config.fabric}
                          value={config.fabric}
                          onChange={e =>
                            config.handleInput({ e, type: "fabricId" })
                          }
                          // isDisabled={
                          //   !config.fabricTradingValue ||
                          //   config.fabricTradingValue?.value === ""
                          // }
                          formatOptionLabel={item => (
                            <FabricOptions item={item} />
                          )}
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      {/* season */}
                      <td style={{ width: 105 }}>⽣地シーズン</td>
                      <td style={{ padding: 5 }}>
                        <SelectBox
                          options={config.seasons}
                          value={config.season}
                          onChange={e => handleInput({ e, type: "seasonId" })}
                          isDisabled={
                            !config.year ||
                            (config.year?.value === "" && !config.fabric) ||
                            config.fabric?.value === ""
                          }
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>ランク</td>
                      <td style={{ padding: 5 }}>
                        <Input
                          type="text"
                          value={config.rank?.rank}
                          disabled
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 105 }}>⽤尺</td>
                      <td style={{ padding: 5, position: "relative" }}>
                        <input
                          value={payload.jacket.scale}
                          onChange={e =>
                            handleInput({
                              e,
                              type: "scale",
                              itemName: "jacket",
                            })
                          }
                          name="scale"
                          style={{ height: 33 }}
                          className="form-control scale-input"
                          type="number"
                        />
                        <p
                          style={{
                            position: "absolute",
                            right: 15,
                            top: 15,
                            opacity: 0.5,
                          }}
                        >
                          M
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/**specifications */}
        {data?.jacket?.specifications.length ? (
          <Card>
            <CardBody>
              <Row>
                {data?.jacket?.specifications &&
                  data.jacket.specifications
                    .filter(spec => spec.formId)
                    .map((spec, idx) => {
                      const defaultValues = payload.jacket.specifications
                      const inputProps = {
                        data: spec,
                        defaultValues,
                        itemName: "jacket",
                        handler: config.handleInput,
                        index: idx,
                      }
                      return (
                        <Col sm={6} key={spec.formId}>
                          <Table bordered>
                            <tbody>
                              {spec.format === null ? (
                                <tr style={{ height: 54 }}>
                                  <td></td>
                                </tr>
                              ) : (
                                <tr style={{ height: 54 }}>
                                  <th style={{ width: 165 }}>{spec.item}</th>
                                  <td style={{ padding: 5 }}>
                                    {spec.format === "チェックボックス" ? ( // checkbox
                                      <Checkbox inputProps={inputProps} />
                                    ) : spec.format === "ラジオボタン" ? ( // Radio
                                      <RadioInput inputProps={inputProps} />
                                    ) : spec.format === "プルダウン" ? ( // select
                                      <DropdownSelect inputProps={inputProps} />
                                    ) : (
                                      <TextInput inputProps={inputProps} />
                                    )}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </Col>
                      )
                    })}
              </Row>
            </CardBody>
          </Card>
        ) : null}
        {/**dimensions */}
        <Card>
          <CardBody>
            <Table bordered>
              <tbody>
                <tr>
                  <td
                    style={{
                      padding: 5,
                      minWidth: 105,
                      verticalAlign: "middle",
                    }}
                  >
                    <p className="mb-0">サイズ</p>
                  </td>
                  <td colSpan={3} style={{ position: "relative" }}>
                    <Input
                      style={{ height: 33, paddingLeft: 30 }}
                      type="text"
                      value={payload?.jacket?.tg}
                      onBlur={e => config.onTgBlur(e, ["上着", "jacket"])}
                      onChange={e =>
                        handleInput({ e, itemName: "jacket", type: "tg" })
                      }
                    />
                    <span
                      style={{
                        position: "absolute",
                        left: 16,
                        top: 18,
                        opacity: 0.5,
                      }}
                    >
                      Tg
                    </span>
                  </td>
                </tr>
                <tr>
                  <th style={{ padding: 5, verticalAlign: "middle" }}>
                    <p className="mb-0">寸法</p>
                  </th>
                  <th style={{ padding: 5 }}>
                    <p className="mb-0 text-center">ゲージ寸法</p>
                  </th>
                  <th style={{ padding: 5 }}>
                    <p className="mb-0 text-center">補正値</p>
                  </th>
                  <th style={{ padding: 5 }}>
                    <p className="mb-0 text-center">上り寸法</p>
                  </th>
                </tr>
                {data.jacket?.dimensions &&
                  data.jacket.dimensions
                    .filter(dim => dim.item)
                    .map((obj, idx) => {
                      const payloadDim = payload.jacket.dimensions
                      return (
                        <tr key={idx}>
                          <th>{obj.item}</th>

                          {[
                            "gaugeDimensions",
                            "correctionValue",
                            "lawToGoUp",
                          ].map(t => (
                            <td style={{ padding: 5 }} key={t}>
                              <DimensionInput
                                name={t}
                                value={payloadDim[idx]?.[t]}
                                onValueChange={(val, name) =>
                                  handleInput({
                                    val,
                                    name,
                                    obj,
                                    idx,
                                    itemName: "jacket",
                                    type: "dimensions",
                                  })
                                }
                              />
                            </td>
                          ))}
                        </tr>
                      )
                    })}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>

      {data?.jacket?.otherDimensions.length ? (
        <Col sm={12}>
          <Card>
            <CardBody>
              <Table bordered responsive>
                <tbody>
                  <tr>
                    {data.jacket?.otherDimensions &&
                      data.jacket.otherDimensions
                        .filter(dim => dim.item)
                        .map((dim, i) => (
                          <th
                            key={i}
                            style={{ minWidth: 150 }}
                            className="text-center"
                          >
                            {dim.item}
                          </th>
                        ))}
                  </tr>
                  <tr>
                    {data.jacket?.otherDimensions &&
                      data.jacket.otherDimensions
                        .filter(dim => dim.item)
                        .map((dim, i) => {
                          return (
                            <td key={i} style={{ minWidth: 150 }}>
                              <Input
                                className="me-2"
                                type="text"
                                data-sequence={1}
                                onChange={e => handleOtherDimension(e, dim, i)}
                                defaultValue={
                                  payload?.jacket?.otherDimensions[i]?.answer
                                }
                              />
                            </td>
                          )
                        })}
                  </tr>
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      ) : null}

      {payload?.memo ? (
        <Col sm={12}>
          <Card>
            <CardBody>
              <p>メモ</p>
              <textarea
                className="form-control"
                rows={8}
                onChange={e => handleInput({ e, type: "memo" })}
              >
                {payload.memo}
              </textarea>
            </CardBody>
          </Card>
        </Col>
      ) : null}

      <Col sm={12}>
        <Row>
          <Col sm={5}>
            <Card>
              <CardBody>
                <Table bordered>
                  <tbody>
                    <tr>
                      <td style={{ width: 105 }}>
                        <p className="mb-0">納品方法</p>
                      </td>
                      <td>
                        <SelectBox
                          options={[
                            { label: "ご来店", value: "ご来店" },
                            { label: "ご配送", value: "ご配送" },
                            {
                              label: "次回オーダー会",
                              value: "次回オーダー会",
                            },
                          ]}
                          value={config.jacketDeliveryMethod}
                          onChange={e =>
                            handleInput({
                              e,
                              type: "deliveryMethod",
                              itemName: "pants",
                            })
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: 105 }}>
                        <p className="mb-0">サンプル</p>
                      </td>
                      <td>
                        <Input
                          type="checkbox"
                          defaultChecked={payload.jacket.sample}
                          onChange={e =>
                            handleInput({
                              e,
                              type: "sample",
                              itemName: "jacket",
                            })
                          }
                          className="me-2"
                          id="サンプル"
                        />
                        <Label className="mb-0" htmlFor="サンプル">
                          サンプル
                        </Label>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <Table bordered>
                  <tbody>
                    <tr>
                      <td style={{ width: 180 }}>
                        下代
                        <br />
                        <small>※直販の場合は上代と同金額です</small>
                      </td>
                      {/* oldAge */}
                      <td>
                        <Input
                          type="number"
                          value={payload.jacket.oldAge}
                          onChange={e =>
                            handleInput({
                              e,
                              type: "oldAge",
                              itemName: "jacket",
                            })
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: 180 }}>予定納品日</td>
                      {/* scheduledDeliveryDate */}
                      <td>
                        <DateInput
                          className="form-control"
                          value={payload.jacket.scheduledDeliveryDate}
                          onChange={e =>
                            handleInput({
                              e,
                              type: "scheduledDeliveryDate",
                              itemName: "jacket",
                            })
                          }
                          placeholder="年/月/日"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: 180 }}>ステータス</td>
                      {/* status */}
                      <td>
                        <Input
                          type="text"
                          className="form-control"
                          value={config.productData.jacket.status}
                          readOnly
                          disabled
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: 180 }}>受注番号</td>
                      {/* order number */}
                      <td>
                        <Input
                          type="text"
                          value={config.productData.orderNumber}
                          disabled
                          readOnly
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
          <Col sm={7}>
            <PaymentForm config={config} payload={payload} itemName="jacket" />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}
